import React from 'react'
import styled from 'styled-components'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'

import apolloClient from '../../../services/ApolloClient'
import ResearchTerritorySelector from './ResearchTerritorySelector'
import { getTerritoryQuery } from '../../../logic/TerritoryQueryUtils'

import { UNLOCKGRAPH_WHEN } from '../../../logic/ResearchConfig'

const STATE = gql`
  query ResearchTerritorySelector {
    research @client {
      selectedFilter
      selectedTerritoryOnModalSelect
      selectedTerritoryTypeOnModalSelect
      selectedTerritoryType
      territoryFilters {
        biomes {
          id
          name          
        }
        regions {
          id
          name,
          cd_muns
        }
        states {
          id
          name,
          cd_muns
        }
        mesoregions {
          id
          name,
          cd_muns
        }
        microregions {
          id
          name,
          cd_muns
        }
        cities {
          id
          name,
          cd_muns
        }
      }
    }
  }
`
export const ASYNC_SELECT_BY_REGIONS_REGION = gql`
  query AsyncSelectByRegionsRegion($name: String!) {
    regionByName(name: $name) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_STATE = gql`
  query AsyncSelectByRegionsState($name: String!, $recgeoIds: [Int!]!) {
    statesByRecGeo(name: $name, recgeo_ids: $recgeoIds, limit: 10000, page: 1) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MESOREGION = gql`
  query AsyncSelectByRegionsMesoregion($name: String!, $recgeoIds: [Int!]!) {
    mesoregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MICROREGION = gql`
  query AsyncSelectByRegionsMicroregion($name: String!, $recgeoIds: [Int!]!) {
    microregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_CITY = gql`
  query AsyncSelectByRegionsCity($name: String!, $recgeoIds: [Int!]!) {
    citiesByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns      
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_BIOME = gql`
  query($name: String!) {
    biomesByName(name: $name) {
      id
      name: nome      
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_CITY = gql`
  query($name: String!, $biomeIds: [Int!]!) {
    citiesByBiome(name: $name, biome_ids: $biomeIds, limit: 10000, page: 1) {
      id
      name: nome
      biomeName: bioma      
    }
  }
`

export default class ResearchTerritorySelectorContainer extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      isAggregated: false
    }

    this.updateFilterSelect = this.updateFilterSelect.bind(this);
    this.updateSelectedModalTerritory = this.updateSelectedModalTerritory.bind(this);
    this.updateIsAggregated = this.updateIsAggregated.bind(this);
  }

  updateFilterSelect(filterName, value) {
    const isAggregated = this.state.isAggregated;

    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          territoryFilters: {
            __typename: 'ResearchTerritoryFiltersState',
            [filterName]: value.results
          }
        }
      }
    })
  }

  onTerritoryFilterSelectChangeFunctions = {
    biomes: (value) => {
      this.updateFilterSelect('biomes', value)
    },
    regions: (value) => {
      this.updateFilterSelect('regions', value)
    },
    region: (value) => {
      this.updateFilterSelect('regions', value)
    },
    states: (value) => {
      this.updateFilterSelect('states', value)
    },
    state: (value) => {
      this.updateFilterSelect('states', value)
    },
    mesoregions: (value) => {
      this.updateFilterSelect('mesoregions', value)
    },
    mesoregion: (value) => {
      this.updateFilterSelect('mesoregions', value)
    },
    microregions: (value) => {
      this.updateFilterSelect('microregions', value)
    },    
    microregion: (value) => {
      this.updateFilterSelect('microregions', value)
    },
    city: (value) => {
      this.updateFilterSelect('cities', value)
    }
  }

  territoryFilterQuery(selectedFilter) {
    switch (selectedFilter) {
      case 'biomes':
        return ASYNC_SELECT_BY_BIOMES_BIOME
      case 'regions':
        return ASYNC_SELECT_BY_REGIONS_REGION
      case 'states':
        return ASYNC_SELECT_BY_REGIONS_STATE
      case 'mesoregions':
        return ASYNC_SELECT_BY_REGIONS_MESOREGION
      case 'microregions':
        return ASYNC_SELECT_BY_REGIONS_MICROREGION
      case 'cities':
        return ASYNC_SELECT_BY_REGIONS_CITY
      default:
        return ASYNC_SELECT_BY_REGIONS_MICROREGION
    }
  }

  territoryQuery(territoryType, searchTerritoryType) {
    return getTerritoryQuery(territoryType, searchTerritoryType);
  }

  updateSelectedFilter(selectedFilterName) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedFilter: selectedFilterName
        }
      }
    })
  }

  updateSelectedModalTerritoryType(territoryType) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedTerritoryTypeOnModalSelect: territoryType
        }
      }
    })
  }

  updateSelectedModalTerritory(territory) {
    const isAggregated = this.state.isAggregated;

    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedTerritoryOnModalSelect: {...territory, isAggregated: isAggregated}
        }
      }
    })
  }

  updateIsAggregated(is) {
    this.state.isAggregated = is;
  }

  render() {
    return (
      <Query query={ STATE }>
        {({ data }) => (
          <ResearchTerritorySelector
            onChangeSelectedFilter={ this.updateSelectedFilter }
            onChangeSelectedTerritoryType={ this.updateSelectedModalTerritoryType }
            onChangeSelectedTerritory={ this.updateSelectedModalTerritory }
            onTerritoryFilterSelectChange={ this.onTerritoryFilterSelectChangeFunctions }
            selectedFilter={ data.research.selectedFilter }
            selectedTerritoryType={ data.research.selectedTerritoryType }
            selectedSearchTerritoryType={ data.research.selectedTerritoryTypeOnModalSelect }
            territoryFilters={ data.research.territoryFilters }
            territoryFilterSource={ this.territoryFilterQuery(data.research.selectedFilter) }
            territorySource={ this.territoryQuery(
              data.research.selectedTerritoryType,
              data.research.selectedTerritoryTypeOnModalSelect
            ) }
          />
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchTerritorySelector/ResearchTerritorySelector.container.js